module.exports = __webpack_public_path__ + "media/images/dummy/main-08da992714184be3569790aa1b2a5490.png";